import DropdownButton from "@mostrans/web-components/components/advanced/Button/DropdownButton";
import Input from "@mostrans/web-components/components/base/Input";
import Select from "@mostrans/web-components/components/base/Select";
import { Divider, Icon, Typography } from "@mui/material";
import React, { useState } from "react";
import { useSetRecoilState } from "recoil";
import {
  valueSearchJobStatusAtoms,
  valueSearchJobsDivisionAtoms, valueSearchJobsNameAtoms
} from "../../../shared/atoms/getValueInputAtoms";
import { useGetMasterDivision } from "../../../shared/hooks/useGetMasterData";
import ModalCreateOpportunity from "./CreateJobs/ModalCreateOpportunity";

function Header(props) {
  const { fetchAllOpportunity } = props;
  const setValueSearchJobsName = useSetRecoilState(valueSearchJobsNameAtoms);
  const setValueSearchByDivision = useSetRecoilState(
    valueSearchJobsDivisionAtoms
  );
  const setValueSearchJobStatus = useSetRecoilState(valueSearchJobStatusAtoms);
  const [labelActive, setLabelActive] = useState("");
  const [listDivision] = useGetMasterDivision();

  const optionDivision = listDivision.map(function (division) {
    return { value: division.division, label: division.division };
  });

  // Clearable Value React Select
  const onChangeDivision = (e) => {
    if (!e) {
      e = {
        value: "",
      };
    }
    setValueSearchByDivision(e.value);
  };

  const filterAllStatusJobs = () => {
    setLabelActive("All Status");
    setValueSearchJobStatus(null);
  };

  const filterActiveStatusJobs = () => {
    setLabelActive("Active");
    setValueSearchJobStatus(true);
  };

  const filterInactiveStatusJobs = () => {
    setLabelActive("Inactive");
    setValueSearchJobStatus(false);
  };

  return (
    <React.Fragment>
      <div className="form-row mb-2">
        <div className="col-md-6">
          <Typography variant="h4" color="InfoText" sx={{ fontWeight: 500 }}>
            Job Listings
          </Typography>
        </div>
      </div>

      <div className="form-row">
        <div className="col-md-10">
          <Input
            type="text"
            placeholder="Search Jobs Name"
            style={{ width: 500 }}
            onChange={(e) => setValueSearchJobsName(e.target.value)}
          />
        </div>
        <div className="col-md-2">
          <ModalCreateOpportunity fetchAllOpportunity={fetchAllOpportunity} />
        </div>
      </div>
      <Divider sx={{ mt: 2, mb: 2 }} />
      <div className="form-row mb-1">
        <div className="col-md-6">
          <Select
            placeholder="Filter By Divisi"
            options={optionDivision}
            isSearchable
            isClearable
            onChange={(e) => onChangeDivision(e)}
            menuPosition="fixed"
          />
        </div>
        <div className="col-md-2"></div>
        <div className="col-md-4">
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <DropdownButton
              label={labelActive ? labelActive : "Filter By Status"}
              buttonProps={{
                variant: "text",
                color: "primary",
                endIcon: <Icon>expand_more</Icon>,
              }}
              autoCloseMenu
              listMenu={[
                {
                  icon: (
                    <Icon className="material-icons-outlined text-primary-main">
                      apps
                    </Icon>
                  ),
                  text: "All Status",
                  onClick: () => filterAllStatusJobs(),
                },
                {
                  icon: (
                    <Icon className="material-icons-outlined text-primary-main">
                      toggle_on
                    </Icon>
                  ),
                  text: "Active",
                  onClick: () => filterActiveStatusJobs(),
                },
                {
                  icon: (
                    <Icon className="material-icons-outlined text-danger">
                      toggle_off
                    </Icon>
                  ),
                  text: "Inactive",
                  onClick: () => filterInactiveStatusJobs(),
                },
              ]}
            />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default Header;
